import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from '../api/index.js';
import { notification } from 'antd';

const handleError = (message) => {
    notification.error({
        message: 'Error',
        description: message || 'Server error',
    });
};

export const fetchTimeSheet = createAsyncThunk(
    'timeSheet/fetch',
    async ({ startDate, endDate }, { rejectWithValue }) => {
        try {
            const result = await API.timeSheet.get(startDate, endDate);
            return result;
        } catch (error) {
            handleError(error.message);
            return rejectWithValue(error.message);
        }
    },
);

export const changeWorkingHours = createAsyncThunk(
    'timeSheet/changeHours',
    async ({ payload }, { rejectWithValue }) => {
        const { teamId, date, hours } = payload;
        try {
            const result = await API.timeSheet.post({ teamId, hours, date });
            return result;
        } catch (error) {
            handleError(error.message);
            return rejectWithValue(error.message);
        }
    },
);
